import "./index.css";

// ─── Component imports ────────────────────────────────────────────────────────
import StarsBackground   from "./StarGenerator/Stars";
import Loader            from "./Loader/Loader";
import Stage             from "./Stage/Stage";
import ConnectForm       from "./ConnectForm/ConnectForm";
import PlanetCards       from "./Cards/PlanetCards";
import ArrowsSVG         from "./ArrowLinesRecalculation/ArrowLines";
import ArrowRecalculation from "./ArrowLinesRecalculation/ArrowRecalculation";
import Navigation        from "./Navigation/Navigation";
import Panel             from "./Panel/Panel";
import CardsPanel        from "./Cards/Cards";

// ─── Data & logic imports ─────────────────────────────────────────────────────
import { CARDS, SOLAR }  from "./data/solarData";
import useAppState       from "./hooks/useAppState";

const PUBLIC_URL = process.env.PUBLIC_URL || "";
const LOGO_SRC = `${PUBLIC_URL}/Hogc.jpeg`;

// ─── App ──────────────────────────────────────────────────────────────────────
export default function App() {
  const {
    cur, loaded, loadPct, loadName,
    panelShow, panelExit, cardsShow,
    navShow, navOpen, flash,
    textures, navTextures, lines,
    isConnect, panelData,
    goTo, handleToggleNav,
  } = useAppState();

  return (
    <main role="main">
      <h1 className="sr-only">HOGC Universe - Curated Ecosystem for AI, Technology, Talent, Marketing & Mobility</h1>
      <StarsBackground />

      <Loader loaded={loaded} loadPct={loadPct} loadName={loadName} logoSrc={LOGO_SRC} />

      <Stage solar={SOLAR} textures={textures} cur={cur} isConnect={isConnect}>
        {isConnect && <ConnectForm />}
      </Stage>

      <div id="vignette" />
      <div id="flash" className={flash ? "pop" : ""} />

      <PlanetCards cardsShow={cardsShow} isConnect={isConnect} cards={CARDS[cur] || CARDS[0]} cur={cur} />

      <ArrowRecalculation>
        <ArrowsSVG cur={cur} cardsReady={cardsShow} lines={lines} isConnect={isConnect} />
      </ArrowRecalculation>

      <Navigation
        navShow={navShow}
        navOpen={navOpen}
        navTextures={navTextures}
        solar={SOLAR}
        cur={cur}
        onGoTo={goTo}
        onToggleNav={handleToggleNav}
        logoSrc={LOGO_SRC}
      />

      <Panel isConnect={isConnect} panelShow={panelShow} panelExit={panelExit} panelData={panelData} cur={cur} />

      <CardsPanel panelData={panelData} panelShow={panelShow} panelExit={panelExit} cards={CARDS[cur] || CARDS[0]} />
    </main>
  );
}
